<script>

export const LinkType = {
    Primary: 'primary',
    Danger: 'danger'
};

</script>
<script setup>
import { computed } from 'vue';

    const props = defineProps({
        type: {type: String, default: LinkType.Primary},
        href: {type: String, default: ''}
    });

    defineEmits(['click']);

    const tag = computed(() => props.href ? 'a' : 'button');
</script>
<template>
    <component :is="tag" :href="href" :class="['action-link', type]" @click="$emit('click')">
        <span>
            <slot/>
        </span>
        <svg width="29" height="15" viewBox="0 0 29 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.85168 7.42256H22.8231" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M16.459 1.85547L22.8233 7.42236L16.459 12.9893" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </component>
</template>
<style lang="scss" scoped>
@import '@Common/Styles/variables';

.action-link {
    color: var(--secondary, map-get($yapla-blue, 600));
    font-weight: 600;
    padding: 0;
    margin: 0;
    display: inline-flex;
    align-items: center;
    gap: 3px;
    transition: gap 0.2s ease-in-out, color 0.2s ease-in-out;
    cursor: pointer;
    border: 0;
    background: transparent;
    outline: 0;
    text-decoration: none;

    &.danger {
        color: map-get($yapla-red, 600);

        &:hover {
            color: map-get($yapla-red, 700);

            svg path {
                stroke: map-get($yapla-red, 700);
            }
        }

        svg path {
            stroke: map-get($yapla-red, 600);
        }
    }

    &:hover {
        color: var(--secondary, map-get($yapla-blue, 700));
        gap: 8px;
        text-decoration: none;

        svg path {
            stroke: var(--secondary, map-get($yapla-blue, 700));
        }
    }

    svg path {
        stroke: var(--secondary, map-get($yapla-blue, 600));
    }
}

</style>
